import SearchCustom from "../../../components/custom/search-custom";
import { ButtonCustom } from "../../../components/custom/button-custom";

interface PromotionAssignBrandFilterProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

export const PromotionAssignBrandFilter = ({
  searchValue,
  setSearchValue,
}: PromotionAssignBrandFilterProps) => {

  return (
    <div
      className="flex flex-wrap md:flex-row justify-end gap-4 md:gap-4"
      id="filter-bar"
    >
      {/* <div className="w-full md:w-auto md:mt-0">
        <SearchCustom
          value={searchValue}
          onChange={(e) => setSearchValue(e)}
          className="w-full md:w-64"
        />
      </div> */}

      {/* <div className="">
        <ButtonCustom
          disabled={!hasChanges}
          type="button"
          text="Reset"
          onClick={handleReset}
          className="text-gray-500 bg-gray-100 hover:bg-gray-400 hover:text-white"
        />
      </div>

      <div className="">
        <ButtonCustom
          type="submit"
          text="Lưu lại"
          onClick={handleSave}
        />
      </div> */}
    </div>
  );
};

